import Modal from "antd/lib/modal/Modal";
import "./IpLogs.scss";
import { Button } from "antd";
import moment from "moment";
import dayjsTZ from "../../../../utils/dayjs";
import { useCallback, useEffect, useState } from "react";
import { htmlParser } from "../../../../utils";
import AgGridComponent from "../../../AG-grid/AgGridComponent";
import { ModalXIcon } from "../../../../assets/icons";
import { useSelector } from "react-redux";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";

const IpLogs = ({ data, isVisible, setIsVisible }) => {
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [tableData, setTableData] = useState([]);
  const authorFormatter = (params) => {
    if (params.value) {
      const author = `${params.value.employeeFirstName} ${params.value.employeeLastname}`;
      return author;
    }
    return "";
  };
  const dateFormatter = (params) => {
    if (params.value) {
      const formattedDate = dayjsTZ(params.value).format("DD/MM/YYYY HH:mm ");
      return formattedDate;
    }
    return "";
  };

  const columnDefs = [
    {
      headerName: "Autori",
      field: "author",
      valueFormatter: authorFormatter,
    },

    {
      headerName: "Koha e ndryshimit",
      field: "changeDate",
      valueFormatter: dateFormatter,
    },
    {
      headerName: "Activity",
      field: "activity",
    },
    {
      headerName: "Ip",
      field: "currentData",
    },
    // {
    //   headerName: "Përshkrimi i kërkesës",
    //   field: "statusDescription",
    //   cellRenderer: ({ value }) => htmlParser(value),
    // },
  ];

  const onFirstDataRendered = useCallback((param) => {
    param.api.autoSizeAllColumns(false);
  }, []);

  useEffect(() => {
    let newData = data?.fieldOptions?.logs;

    setTableData(newData);
  }, [isVisible]);

  return (
    <Modal
      className={`ipLogs ${isDarkMode ? "dark darkHeader" : "lightHeader"}`}
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      destroyOnClose
      title="Paisjet Logs"
      closeIcon={<ModalXIcon />}
      width={650}
      footer={[
        <MondayButton
          className="mondayButtonRed"
          onClick={() => setIsVisible(false)}
        >
          Mbyllni faqen
        </MondayButton>,
      ]}
    >
      <AgGridComponent
        columnDefs={columnDefs}
        customDefaultColDef={{ flex: undefined }}
        rowData={tableData}
        overlayLoadingTemplate="Historiku është bosh!"
        autoSizeStrategy={{ type: "fitCellContents" }}
        onFirstDataRendered={onFirstDataRendered}
      />
    </Modal>
  );
};

export default IpLogs;
